import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import FormList from 'apps/web_forms/components/FormList';
import FormListElement from 'apps/web_forms/components/FormListElement';
import { ids, ModalTypes } from 'apps/web_forms/utils/constants';
import { setModal } from 'apps/web_forms/slices/appSlice';

const DraftList = ({
  title,
  description = '',
  loading,
  draftsToList,
  goToForm,
}) => {
  const dispatch = useDispatch();
  return (
    <FormList
      header
      title={title}
      description={description}
      loading={loading}
      forms={draftsToList}
      searchBarSticky
    >
      {(draft, index) => {
        const openButton = {
          id: ids.DraftsIds.OpenButton,
          label: 'Open',
          onClick: (draftId) => goToForm(draft.form_id, draftId),
          highlighted: true,
        };
        const copyButton = {
          id: ids.DraftsIds.CopyButton,
          label: 'Copy',
          onClick: (draftId) =>
            dispatch(
              setModal({
                type: ModalTypes.COPY_DRAFT_MODAL,
                extraProps: {
                  draftId,
                },
              })
            ),
          highlighted: false,
        };
        const deleteButton = {
          id: ids.DraftsIds.DeleteButton,
          label: 'Delete',
          onClick: (draftId) => {
            dispatch(
              setModal({
                type: ModalTypes.DELETE_DRAFT_MODAL,
                extraProps: {
                  selectedDraftId: draftId,
                },
              })
            );
          },
          highlighted: false,
          red: true,
        };
        const reassignButton = {
          id: ids.DraftsIds.ReassignButton,
          label: 'Reassign',
          onClick: (draftId) => {
            dispatch(
              setModal({
                type: ModalTypes.DRAFT_REASSIGNMENT_MODAL,
                extraProps: {
                  draftIdToReassign: draftId,
                },
              })
            );
          },
          highlighted: false,
          red: false,
        };
        // Can't copy dispatch drafts
        let buttons = draft?.type === "DISPATCH_DRAFT" ? [openButton, deleteButton] : [openButton, copyButton, deleteButton]
        
        if (window.isDraftReassignmentEnabled && draft.is_draft_reassignable) {
          buttons.push(reassignButton);
        }

        return (
          <FormListElement
            index={index}
            key={draft.identifier}
            identifier={draft.identifier}
            title={draft.title}
            subtitle={`Saved on ${moment(draft.updated_at).format(
              'MMM Do YYYY, h:mm:ss A'
            )}`}
            label='Draft'
            description={draft?.description || ''}
            onClick={(draftId) => goToForm(draft.form_id, draftId)}
            buttons={buttons}
            moreOption
          />
        );
      }}
    </FormList>
  );
};

DraftList.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  draftsToList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  goToForm: PropTypes.func.isRequired,
};

export default DraftList;
